import {createAsyncThunk} from "@reduxjs/toolkit";
import {IRolesCreate, IRolesPayload} from "../types";
import {IErrorResponse, IRootState,} from "../../../../../../../types";
import request from "../../../../../../../service";
import {deletedRestoreRoles, deletedRoles, setRoles, setRolesRestore} from "./rolesSlice";



const CreateRoles = createAsyncThunk(
    "create/roles",
    async (data:IRolesCreate,{rejectWithValue})=>{
        try {
            const response = await request.post("/roles",data);

            return response.data
        }
        catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const GetRoles = createAsyncThunk(
    "get/roles",
    async(_,{dispatch,rejectWithValue,getState})=>{

        try {
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            const response = await request.get("/roles");


            dispatch(setRoles({data:response.data,defaultLanguage}));
            return response.data
        }
        catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const DeleteRoles = createAsyncThunk(
    "delete/roles",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/roles/${id}`);

            dispatch(deletedRoles(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditRoles = createAsyncThunk(
    "edit/roles",
    async (data: IRolesPayload, {  rejectWithValue }) => {
        try {
            const response = await request.put(`/roles/${data.id}`, data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeleteRoles = createAsyncThunk(
    "get/delete/roles",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/roles/deleted-items`);

            dispatch(setRolesRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteRoles= createAsyncThunk(
    "restore/delete/roles",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/roles/restore/${id}`);

            dispatch(deletedRestoreRoles(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export{
    CreateRoles,
    GetRoles,
    DeleteRoles,
    EditRoles,
    RestoreDeleteRoles,
    GetDeleteRoles
}